<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 13:33:54
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 13:33:54
  * @Description: 会议室预约表单
  * @FilePath:@/components/meetingFrom.vue
-->
<template>
  <div>
    <van-form @submit="onSubmit">
      <!-- 会议标题 -->
      <van-field
        v-model="formData.meeting_title"
        name="meeting_title"
        label="会议标题"
        placeholder="会议标题"
      />
      <!-- 会议室选择 -->
      <PickerForm
        :label="'会议室'"
        :name="'meeting_code'"
        :picker-type="'meeting'"
        :right-icon="'arrow'"
        :default-value="roomCode"
      />
      <div class="van-field-line" />
      <!-- 会议内容 -->
      <van-field
        v-model="formData.meeting_content"
        name="meeting_content"
        label="会议内容"
        placeholder="会议内容"
      />
      <!-- 是否是重复日期 -->
      <van-field name="meeting_radioTime" label="周期预约">
        <template #input>
          <van-radio-group v-model="formData.meeting_radioTime" direction="horizontal">
            <van-radio name="1" icon-size="15px">否</van-radio>
            <van-radio name="2" icon-size="15px">是</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 选择周期性-->
      <van-field v-if="formData.meeting_radioTime ==='2'" name="meeting_radioCategory" label="重复周期">
        <template #input>
          <van-radio-group v-model="formData.meeting_radioCategory" direction="horizontal">
            <van-radio name="0" icon-size="15px">每天</van-radio>
            <van-radio name="1" icon-size="15px">每周</van-radio>
            <van-radio name="2" icon-size="15px">每月</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 会议开始日期 -->
      <pickerTimeForm
        :label="'预约日'"
        :name="'meeting_time_s'"
        :right-icon="'arrow'"
        :default-value="formData.meeting_time_s"
        @PickerMeetingtime="PickerMeetingtime"
      />
      <div class="van-field-line" />
      <!-- 会议结束日期 -->
      <pickerTimeForm
        v-if="formData.meeting_radioTime ==='2'"
        :label="'结束日期'"
        :name="'meeting_time_e'"
        :right-icon="'arrow'"
        :default-value="formData.meeting_time_e"
        @PickerMeetingtimeEnd="PickerMeetingtimeEnd"
      />
      <!-- 月 周选择 -->
      <PickerForm
        v-if="formData.meeting_radioCategory==='2'&&formData.meeting_radioTime ==='2'"
        ref="pickerForm"
        :values="formData.meeting_week_num"
        :label="'选择周期'"
        :name="'mouth'"
        :picker-type="'week'"
        :right-icon="'arrow'"
        :test="pickMouthData"
        @PickerForm="PickerFormMouth"
      />
      <!-- 选择周几   -->
      <van-field v-if="formData.meeting_radioTime ==='2'&& formData.meeting_radioCategory!=='0'" name="meeting_weekGroup" label="选择星期">
        <template #input>
          <van-checkbox-group v-model="formData.meeting_weekGroup" direction="horizontal">
            <van-checkbox name="1" shape="square" icon-size="15px">周一</van-checkbox>
            <van-checkbox name="2" shape="square" icon-size="15px">周二</van-checkbox>
            <van-checkbox name="3" shape="square" icon-size="15px">周三</van-checkbox>
            <van-checkbox name="4" shape="square" icon-size="15px">周四</van-checkbox>
            <van-checkbox name="5" shape="square" icon-size="15px">周五</van-checkbox>
            <van-checkbox name="6" shape="square" icon-size="15px">周六</van-checkbox>
            <van-checkbox name="7" shape="square" icon-size="15px">周日</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <!-- 会议开始时间 -->
      <PickerForm
        :label="'开始时间'"
        :name="'meeting_time_s_t'"
        :meeting_time_s="'开始时间'"
        :default-value="formData.meeting_time_s_t"
        :picker-type="'time'"
        :meeting-tadiotime="formData.meeting_radioTime"
        :upd-insflg="upd_ins_flg"
        :meeting-value="meeting_value"
        :right-icon="'arrow'"
        @PickerForm="PickerFormFunc"
      />
      <div class="van-field-line" />

      <!-- <div class="van-field-line" /> -->
      <!-- 会议结束时间 -->
      <PickerForm
        :label="'结束时间'"
        :name="'meeting_time_e_t'"
        :default-value="formData.meeting_time_e_t"
        :picker-type="'time'"
        :meeting-tadiotime="formData.meeting_radioTime"
        :upd-insflg="upd_ins_flg"
        :meeting-value="meeting_value"
        :right-icon="'arrow'"
        @PickerFormEnd="PickerFormEndFunc"
      />
      <div class="van-field-line" />
      <!-- 发起人 -->
      <MeetGetUser
        :label="'发起人'"
        :name="'user_name'"
        :default-value="user"
        :right-icon="'arrow'"
        :list="allUserData"
      />
      <div class="van-field-line" />
      <!-- 预约人 -->
      <van-field label="预约人" :value="userCeate" readonly />
      <selectParticipants
        ref="selectParticipants"
        :department-data="departmentData"
        :all-users="allUserData"
        :meeting-users="meetingUsers"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    <div class="gf">
      <p> 会议室使用规范:<br>
        1.会议室用途<br>
        会议室为公司会议、部门会议、视频会议、项目组会议、员工培训、面谈、招聘面试、客户接待以及小型活动、竞赛等活动的场所，未经允许不得挪为他用。<br>
        2.管理<br>
        会议室的管理由人事部门统一负责。<br>
        3.预约<br>
        会议室使用原则为先预约后使用，预约方式：电脑登录DXWSOFT（会议预定）或登入企业微信预订。预约成功后应在预约时间到达会议室，15分钟内仍未到达使用者，
        公司有权对会议室的使用权另作安排。为合理利用资源，临时取消会议者应在预约平台进行取消预约的操作。<br>
        4.使用<br>
        会议室使用时请将指示牌翻至“会议中”，以免会议被打扰。桌椅轻拿轻放，禁止大声喧哗。会议期间请爱惜会议室的设备及物品，如需其它设备请联系人事进行准备。如遇网络及硬件问题，请联系运维组同事进行调试。<br>
        5.离场<br>
        会议结束后，请将自身携带物品拿走，并将会议室物品复原，且不得将其带离。保持会议室卫生整洁，并将用过的白板清理干净。将电视、电脑、投影等电子设备的电源切断，灯、空调、门、窗关闭，指示牌翻至“空闲中”。<br>
        6.注意<br>
        违反以上规定者，视情节严重大小，公司将进行提醒或警告。</p>
    </div>

  </div>
</template>

<script>
import request from '@/utils/request'
import MeetGetUser from '@/components/MeetingReservation/meetGetUser'
import selectParticipants from '@/components/MeetingReservation/selectParticipants'

import PickerForm from '@/components/formComm/pickerForm'
import pickerTimeForm from '@/components/formComm/pickerTimeForm'
import { getItem } from '@/utils/auth'
import { GetUserList, GetDeptList, InsertMeeting, UpdateMeeting } from '@/api/Meeting'
import { GetMeeting } from '@/api/Meeting'
export default {
  name: 'MeetingFrom',
  components: { PickerForm, pickerTimeForm, MeetGetUser, selectParticipants },
  props: {
    meetingData: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      userCeate: '',
      user: '',
      endTime: '',
      // 表单数据
      formData: {
        meeting_title: '',
        meeting_code: '',
        meeting_content: '',
        meeting_time_s: '',
        meeting_time_s_t: '',
        meeting_time_e: '',
        meeting_time_e_t: '',
        user_name: '',
        meeting_users: '',
        meeting_weekGroup: ['1'],
        // 是否是重复日期 1 否  2 是
        meeting_radioTime: '1',
        // 0 每天 1 每周  2 每月
        meeting_radioCategory: '0',
        // 预约人
        userCeate: '',
        // 第几周
        meeting_week_num: ''
      },
      // 所有用户
      allUserData: [],
      // 所有部门
      departmentData: [],
      // 参会人
      meetingUsers: [],
      // 所有数据
      AllData: [],
      timeShow: null,
      pickMouthData: null,
      upd_ins_flg: '',
      meeting_value: '',
      newcycledata: [],
      flg: 0,
      meetingUsrsflg: 0,
      meetingUsrs: ''
    }
  },
  computed: {
    roomCode: function() {
      var code = ''
      if (this.meetingData.type === 'day') {
        if (this.meetingData.data !== '[object Object]') {
          const data = this.meetingData.data[0].room_code
          code = '会议室' + data.replace(/[^0-9]/ig, '')
        }
      } else if (this.meetingData.type === 'mouth') {
        if (this.meetingData.data !== '[object Object]') {
          code = this.meetingData.data[0].roomName
        }
      } else {
        code = '会议室' + this.meetingData.data.room_code
      }

      return code
    }
  },
  watch: {
    timeShow(nVal) {
      // console.log(nVal)
    }
  },
  created() {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
    this.upd_ins_flg = this.meetingData.type
    this.meeting_value = this.meetingData.data.meeting_value
    if (this.meetingData.type === 'updata') {
      if (this.$route.query.cycleMeet === 'true') {
        if (this.meetingData.data.meeting_value === '0') {
          this.formData.meeting_radioTime = '1'
        } else if (this.meetingData.data.meeting_value === '1') {
          this.getData(this.meetingData.data.meeting_group)
          this.formData.meeting_radioTime = '2'
          this.formData.meeting_radioCategory = '0'
        } else if (this.meetingData.data.meeting_value === '2') {
          this.getData(this.meetingData.data.meeting_group)
          this.formData.meeting_radioTime = '2'
          this.formData.meeting_radioCategory = '1'
        } else if (this.meetingData.data.meeting_value === '3') {
          this.getData(this.meetingData.data.meeting_group)
          this.formData.meeting_radioTime = '2'
          this.formData.meeting_radioCategory = '2'
        }
      }
      if (this.meetingData.data.meeting_week_num === '1') {
        this.formData.meeting_week_num = '第一周'
      } else if (this.meetingData.data.meeting_week_num === '2') {
        this.formData.meeting_week_num = '第二周'
      } else if (this.meetingData.data.meeting_week_num === '3') {
        this.formData.meeting_week_num = '第三周'
      } else if (this.meetingData.data.meeting_week_num === '4') {
        this.formData.meeting_week_num = '第四周'
      } else if (this.meetingData.data.meeting_week_num === '5') {
        this.formData.meeting_week_num = '第五周'
      } else {
        this.formData.meeting_week_num = this.meetingData.data.meeting_week_num
      }
      this.$store.dispatch('meetingtime/meetingCount', this.meetingData.data.meeting_time_s)
      this.formData.meeting_title = this.meetingData.data.meeting_title
      this.formData.meeting_num = this.meetingData.data.meeting_num
      this.formData.meeting_content = this.meetingData.data.meeting_content
      this.formData.meeting_users = this.meetingData.data.meeting_users
      this.formData.meeting_time_s = this.meetingData.data.meeting_time_s
      this.formData.meeting_time_s_t = this.meetingData.data.meeting_time_s_t
      this.formData.meeting_time_e = this.meetingData.data.meeting_time_e
      this.formData.meeting_time_e_t = this.meetingData.data.meeting_time_e_t
      this.formData.user_name = this.meetingData.data.register_user
      this.formData.meeting_weekGroup = this.meetingData.data.meeting_week === null ? ['1'] : this.meetingData.data.meeting_week.split(',')
      this.user = this.meetingData.data.user_name + '(' + this.meetingData.data.register_user + ')'
      this.getUserList()
      this.userCeate = this.$store.getters.username + ' (' + this.meetingData.data.create_user + ')'
    } else {
      this.$store.dispatch('meetingtime/meetingCount', this.meetingData.data[0].startime)
      this.formData.meeting_time_s = this.meetingData.data[0].startime
      this.formData.meeting_time_e = this.meetingData.data[0].startime
      this.formData.meeting_title = ''
      this.formData.meeting_content = ''
      this.formData.meeting_users = ''
      // 当前时间时
      let Hours = new Date().getHours()
      if (Hours < 10) {
        Hours = '0' + Hours
      }
      // 当前时间分钟
      const minutes = new Date().getMinutes()
      // 当前时间分钟向上取整为1， 当前分钟为15
      if (Math.ceil(minutes / 15) === 1) {
        this.formData.meeting_time_s_t = String(Hours + ':15:00')
      // 当前时间分钟向上取整为2， 当前分钟为30
      } else if (Math.ceil(minutes / 15) === 2) {
        this.formData.meeting_time_s_t = String(Hours + ':30:00')
      // 当前时间分钟向上取整为2， 当前分钟为45
      } else if (Math.ceil(minutes / 15) === 3) {
        this.formData.meeting_time_s_t = String(Hours + ':45:00')
      // 当前时间分钟向上取整为2， 当前分钟为00
      } else if (Math.ceil(minutes / 15) === 4) {
        let Hoursbv = parseInt(Hours) + 1
        if (Hoursbv < 10) {
          Hoursbv = '0' + Hoursbv
        }
        this.formData.meeting_time_s_t = Hoursbv + ':00:00'
      } else if (Math.ceil(minutes / 15) === 0) {
        this.formData.meeting_time_s_t = String(Hours + ':00:00')
      }
      // 开始时间是24:00:00的场合
      if (this.formData.meeting_time_s_t === '24:00:00') {
        this.formData.meeting_time_s_t = '00:00:00'
      }
      // 结束时间
      let Hourset = parseInt(this.formData.meeting_time_s_t.split(':')[0]) + 1
      if (Hourset < 10) {
        Hourset = '0' + Hourset
      }
      const Minuteset = this.formData.meeting_time_s_t.split(':')[1] + ':' + this.formData.meeting_time_s_t.split(':')[2]
      if (Hourset >= 23) {
        this.formData.meeting_time_e_t = '00:00:00'
      } else {
        this.formData.meeting_time_e_t = Hourset + ':' + Minuteset
      }
      // this.formData.meeting_time_s_t = '08:30:00'
      // this.formData.meeting_time_e_t = '09:30:00'
      // this.formData.meeting_time_s = this.$moment(new Date()).format('YYYY-MM-DD')
      // this.formData.meeting_time_e = this.$moment(new Date()).format('YYYY-MM-DD')
      var UserCode = getItem().Login_UserCode
      this.user = getItem().username + '(' + UserCode + ')'
      this.getUserList()
      const self = this
      request({ url: '/C00/UserInfo', params: { user_code: this.$store.getters.usercode }})
        .then(function(response) {
          self.userCeate = response.data.user_name + ' (' + response.data.user_code + ')'
        })
    }
    // this.userCeate = getItem().username + '(' + getItem().Login_UserCode + ')'
  },
  mounted() {
    if (this.formData.meeting_radioCategory === '2' && this.formData.meeting_radioTime === '2') {
      this.$nextTick(() => {
        this.pickMouthData = this.$refs.pickerForm.columns.find(data => data.text === this.formData.meeting_week_num)
      })
    }
    var _this = this
    GetMeeting(function(res) {
      _this.AllData = res.data
    })
  },
  methods: {
    // 获取开始时间  结束时间+1
    PickerFormFunc(val) {
      let parameter = parseInt(val[0].text) + 1
      if (parameter < 10) {
        parameter = '0' + parameter
      }
      // 结束时间+1等于24的场合
      if (parameter === 24) {
        this.formData.meeting_time_e_t = '00:00:00'
      } else {
        this.formData.meeting_time_e_t = parameter + ':' + val[1].text + ':00'
      }
    },
    // 获取结束时间
    PickerFormEndFunc(val) {
      this.formData.meeting_time_e_t = val[0].text + ':' + val[1].text + ':00'
    },
    getUserList() {
      var _this = this
      GetUserList({ user_code: '2008001' }, function(res) {
        _this.allUserData = res.data
        if (_this.formData.user_name) {
          _this.user = _this.allUserData.filter(item => item.value === _this.formData.user_name)[0].text
        }
        if (_this.formData.meeting_users) {
          let arrs
          if (_this.meetingUsrsflg === 1) {
            arrs = _this.meetingUsrs.split(',')
          } else {
            arrs = _this.formData.meeting_users.split(',')
          }
          arrs.forEach(element => {
            _this.meetingUsers.push(_this.allUserData.filter(item => item.value === element)[0])
          })
        }
      })
      GetDeptList({ department: '0000000000' }, function(res) {
        _this.departmentData = res.data
      })
    },
    isTimes(startdate, enddate, newdate, roomcode) {
      var _this = this
      if (_this.AllData) {
        const arrTime = _this.AllData.filter(item => item.room_code === roomcode)
        arrTime.forEach(element => {
          const starTime = _this.$moment(element.meeting_time_s).format('YYYY-MM-DD HH:mm:ss')
          const endime = _this.$moment(element.meeting_time_e).format('YYYY-MM-DD HH:mm:ss')
          const starS = _this.$moment(startdate).isBefore(starTime)
          const starE = _this.$moment(startdate).isBefore(endime)
          const endS = _this.$moment(enddate).isBefore(starTime)
          const endE = _this.$moment(enddate).isBefore(endime)
          if (!starS && starE || !endS && endE) {
            _this.timeShow = false
          } else if (starS && !endS) {
            _this.timeShow = false
          } else {
            _this.timeShow = true
          }
        })
      }
      return _this.timeShow
    },
    // 获取当月第几周
    getMonthWeek(a, b, c) {
      /**
        * a = d = 当前日期
        * b = 6 - w = 当前周的还有几天过完(不算今天)
        * a + b 的和在除以7 就是当天是当前月份的第几周
        */
      var date = new Date(a, parseInt(b) - 1, c)
      var w = date.getDay()
      var d = date.getDate()
      if (w === 0) {
        w = 7
      }
      var config = {
        getMonth: date.getMonth() + 1,
        getYear: date.getFullYear(),
        getWeek: Math.ceil((d + 6 - w) / 7)
      }
      return config
    },
    // 获取月周期
    PickerFormMouth(value) {
      this.pickMouthData = value
    },
    // 获取两个日期之间的日期
    getMonthBetween(starDate, endDate) {
      // category 0 每天  1 每周 2 每月
      // 初始化日期列表，数组
      var diffdate = []
      var i = 0
      // 开始日期小于等于结束日期,并循环
      while (starDate <= endDate) {
        diffdate[i] = starDate
        // 获取开始日期时间戳
        var stime_ts = new Date(starDate).getTime()
        // 增加一天时间戳后的日期
        var next_date = stime_ts + (24 * 60 * 60 * 1000)
        // 拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear() + '-'
        var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-'
        var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate()
        starDate = next_dates_y + next_dates_m + next_dates_d
        // 增加数组key
        i++
      }
      // console.log(diffdate)
      return diffdate
    },

    // 插入会议信息
    InsertMeetingFunc(values, usersStr) {
      var dayArr = []
      var dateAll = []
      var meetingVal = null
      if (values.meeting_radioTime === '1') {
        // 如果不是重复日期
        meetingVal = '0'
        dayArr = this.getMonthBetween(values.meeting_time_s, values.meeting_time_s)
        // dayArr = dateAll
      } else {
        dateAll = this.getMonthBetween(values.meeting_time_s, values.meeting_time_e)
        if (values.meeting_radioCategory === '0') {
        // 每天
          meetingVal = '1'
          dayArr = dateAll
        } else if (values.meeting_radioCategory === '1') {
        // 每周
          meetingVal = '2'
          const weekGroup = values.meeting_weekGroup
          for (let w = 0; w < dateAll.length; w++) {
            const weekOfDay = this.$moment(dateAll[w]).format('E')
            if (weekGroup.includes(weekOfDay)) {
              dayArr.push(dateAll[w])
            }
          }
        } else if (values.meeting_radioCategory === '2') {
        // 每月
          meetingVal = '3'
          if (this.pickMouthData) {
            for (let m = 0; m < dateAll.length; m++) {
              const element = dateAll[m].split('-')
              var getDate = this.getMonthWeek(element[0], element[1], element[2])
              if (getDate.getWeek === this.pickMouthData.index) {
                const weekGroup = values.meeting_weekGroup
                const weekOfDay = this.$moment(dateAll[m]).format('E')

                if (weekGroup.includes(weekOfDay)) {
                  var ele = element[0] + '-' + element[1] + '-' + element[2]
                  dayArr.push(ele)
                }
              }
            }
          }
        }
      }
      if (this.meetingData.type === 'updata') {
        const num = this.meetingData.data.meeting_num
        var updata = []
        for (let h = 0; h < dayArr.length; h++) {
          const element = dayArr[h]
          updata.push({
            meeting_num: num[h] ? num[h] : null,
            meeting_value: meetingVal,
            meeting_title: values.meeting_title,
            room_code: values.meeting_code.replace(/[^0-9]/ig, ''),
            meeting_content: values.meeting_content,
            create_user: getItem().Login_UserCode,
            meeting_time_s: element + ' ' + values.meeting_time_s_t,
            meeting_time_e: element + ' ' + values.meeting_time_e_t,
            meeting_users: usersStr,
            meeting_week: values.meeting_weekGroup ? values.meeting_weekGroup.toString() : null,
            meeting_week_num: values.mouth ? values.mouth : null,
            register_user: values.user_name.replace(/[^0-9]/ig, ''),
            meeting_group: this.meetingData.data.meeting_group.toString()
          })
        }
        return updata
      } else {
        const data = []

        for (let h = 0; h < dayArr.length; h++) {
          const element = dayArr[h]
          const obj = {}
          // 插入
          obj.meeting_value = meetingVal
          obj.meeting_title = values.meeting_title
          obj.room_code = values.meeting_code.replace(/[^0-9]/ig, '')
          obj.meeting_content = values.meeting_content
          obj.create_user = getItem().Login_UserCode
          obj.meeting_time_s = element + ' ' + values.meeting_time_s_t
          obj.meeting_time_e = element + ' ' + values.meeting_time_e_t
          obj.meeting_users = usersStr
          obj.register_user = values.user_name.replace(/[^0-9]/ig, '')
          obj.meeting_week = values.meeting_weekGroup ? values.meeting_weekGroup.toString() : null
          obj.meeting_week_num = values.mouth ? values.mouth : null
          data.push(obj)
        }
        return data
      }
    },
    // 提交表单
    onSubmit(values) {
      const _this = this
      var users = []
      const userList = this.$refs.selectParticipants.userList

      if (userList.length) {
        userList.forEach(element => {
          users.push(element.value)
        })
      }
      var usersStr = users.join(',')
      //  else {
      //   this.$toast('参会人不得为空')
      //   return
      // }

      if (values.meeting_title === '') {
        this.$toast('会议标题不得为空')
        return
      }
      const startime = values.meeting_time_s + ' ' + values.meeting_time_s_t
      var endtime = ''
      // 结束日期是'00:00:00'的场合，日期加一天
      if (values.meeting_time_e_t === '00:00:00') {
        const meeting_date = this.$moment(values.meeting_time_s).add(1, 'days').format('YYYY-MM-DD')
        endtime = meeting_date + ' ' + values.meeting_time_e_t
      } else {
        endtime = values.meeting_time_s + ' ' + values.meeting_time_e_t
      }
      if (this.$moment(endtime).isBefore(startime) || this.$moment(endtime).isSame(startime)) {
        this.$toast('会议室结束时间不得小于等开始时间！')
        return
      }
      if (this.$moment(endtime).isBefore(startime) || this.$moment(endtime).isSame(startime)) {
        this.$toast('会议室结束时间不得小于等开始时间！')
        return
      }
      if (values.meeting_radioCategory === '2' && this.pickMouthData == null) {
        this.$toast('请选择周期')
        return
      }
      var data = _this.InsertMeetingFunc(values, usersStr)
      // 有符合的数据
      if (data.length > 0) {
        if (this.meetingData.type === 'updata') {
          if (data[0].meeting_value === '0' || data[0].meeting_value === '4') {
            const fztime = values.meeting_time_s + ' ' + values.meeting_time_e_t
            if (_this.$moment(fztime).format('YYYY-MM-DD HH:mm:ss') < _this.$moment().format('YYYY-MM-DD HH:mm:ss')) {
              this.$toast('预约时段只能选择未来时间，请重新确认！')
              return
            }
          }
          const datalist = []
          data.forEach(i => {
            datalist.push(i.meeting_time_e)
          })
          const moments = datalist.map(d => _this.$moment(_this.$moment(d).format('YYYY-MM-DD HH:mm:ss')))
          // 最大会议结束时间
          const maxdataEnd = _this.$moment.max(moments)._i
          // 最小会议结束时间
          const mindataEnd = _this.$moment.min(moments)._i
          UpdateMeeting(data, function(res) {
            if (res.code === 0) {
              if (_this.$moment().format('YYYY-MM-DD HH:mm:ss') > mindataEnd && _this.$moment().format('YYYY-MM-DD HH:mm:ss') < maxdataEnd) {
                _this.$toast({ message: '提交成功，会议周期包含已结束的会议，本次修改内容仅适用于未来时间的会议。', duration: 5000 })
              } else {
                _this.$toast.success('提交成功')
                // _this.$toast({ message: '提交成功', duration: 8000 })
              }
              _this.$router.go(-1)
              // _this.$router.push(
              //   { path: '/index/Meeting' }
              // )
            } else if (res.code === 6) {
              const tips = '该会议已被预约！  ' + '会议室' + res.parm[0].room_code + ' ' + _this.$moment(res.parm[0].meeting_time_s).format('YYYY-MM-DD') + ' ' +
              _this.$moment(res.parm[0].meeting_time_s).format(' HH:mm:ss') + '-' + _this.$moment(res.parm[0].meeting_time_e).format(' HH:mm:ss')
              _this.$toast(tips)
            } else {
              _this.$toast.fail('提交失败')
            }
          })
        } else {
          InsertMeeting(data, function(res) {
            if (res.code === 0) {
              _this.$toast.success('提交成功')
              _this.$router.go(-1)
              // _this.$router.push(
              //   { path: '/index/Meeting' }
              // )
            } else if (res.code === 6) {
              const tips = '该会议已被预约！  ' + '会议室' + res.parm[0].room_code + ' ' + _this.$moment(res.parm[0].meeting_time_s).format('YYYY-MM-DD') + ' ' +
              _this.$moment(res.parm[0].meeting_time_s).format(' HH:mm:ss') + '-' + _this.$moment(res.parm[0].meeting_time_e).format(' HH:mm:ss')
              _this.$toast(tips)
            } else {
              _this.$toast.fail('提交失败')
            }
          })
        }
      // 没有符合的数据
      } else {
        _this.$toast('选择的会议周期没有符合的周期，请重新确认会议周期预定时间')
      }
    },
    PickerMeetingtime(val) {
      this.$store.dispatch('meetingtime/meetingCount', val)
    },
    PickerMeetingtimeEnd(val) {
      this.$store.dispatch('meetingtime/meetingCount', this.formData.meeting_time_s)
    },
    getData(data) {
      const that = this
      request({ url: 'C05/CycleData', params: { meeting_group: data }})
        .then(function(response) {
          for (var i = 0; i < response.data.length; i++) {
            if (that.$moment(response.data[i].meeting_time_e).format('YYYY-MM-DD HH:mm:ss') > that.$moment().format('YYYY-MM-DD HH:mm:ss')) {
              that.flg = that.flg + 1
            }
            if (that.flg === 1) {
              that.meetingUsrsflg = 1
              that.meetingUsrs = response.data[i].meeting_users
              that.formData.meeting_time_s_t = that.$moment(response.data[i].meeting_time_s).format('HH:mm:ss')
              that.formData.meeting_time_e_t = that.$moment(response.data[i].meeting_time_e).format('HH:mm:ss')
            }
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang='scss' scoped>
.gf{
    background: #f7f8fa;
    margin-bottom: 50px;
}
.gf p{
      font-size: 12px;
    padding: 0 10px;
    color: #868585;
        height: 461px;
}
.van-field-line {
    box-sizing: border-box;
    pointer-events: none;
    width: calc(100%-32px);
    margin: 0 16px;
    height: 1px;
    border-bottom: 1px solid #f6f6f7;
}
/deep/.van-checkbox--horizontal{
  margin: 3px 5px;
}
</style>
